import * as z from "zod";

export const getCustomerSubscriptionTotalSpent = {
  name: "getCustomerSubscriptionTotalSpent" as const,
  input: z.object({ customerId: z.number() }),
  output: z.object({ totalSpent: z.string(), totalCharges: z.number() }),
};
